/* eslint-disable react-hooks/exhaustive-deps */
declare var window: any
import { createContext, useEffect, useState } from 'react'
import Data from '../services/contractAddress.json'
// import { useChain, useMoralis } from "react-moralis";
import { Biconomy } from '@biconomy/mexa'
import Web3 from 'web3'
// import { networkConfigs } from "../helpers/network";
import alterBodyABI from '../services/ABI/alterBodyABI.json'
import { useWeb3Auth } from '../services/web3auth'
// import alterPortalAccess from "../contract_address/alterPortalAccess.json"
// import biconomyApiKey from "../helpers/biconomy";

export const BiconomyContext = createContext({})

const BiconomyContextProvider = (props: any) => {
  const biconomyApiKey = process.env.NEXT_PUBLIC_BICONOMY_API_KEY
  const nftContractAddress = Data.nftContractAddress
  const RPCURL =
    'https://polygon-mumbai.g.alchemy.com/v2/dXk13kYJeS2U4TCHa63EYGBBsX-z_-fk'
  const { children } = props
  const { web3WalletProvider } = useWeb3Auth()
  // const {
  //   isWeb3Enabled,
  //   web3,
  //   user,
  //   isAuthenticated,
  //   account,
  //   isWeb3EnableLoading,
  //   enableWeb3,
  //   Moralis,
  // } = useMoralis();

  // const { chainId } = useChain();
  const [isBiconomyInitialized, setIsBiconomyInitialized] = useState(false)
  const [biconomyProvider, setBiconomyProvider] = useState({})
  const [contractAlter, setContract] = useState({})
  const { abi } = alterBodyABI
  //   const contractAddress = useMemo(() => alterPortalAccess["0x89"], [chainId]);

  //   useEffect(() => {
  //     if ((isAuthenticated || account || user?.get('ethAddress')) && !isWeb3Enabled && !isWeb3EnableLoading && chainId) {
  //       enableWeb3();
  //     }
  //   }, [isAuthenticated, isWeb3Enabled, chainId, account]);

  useEffect(() => {
    const initializeBiconomy = async () => {
      // console.log("inside use effect");
      if (isBiconomyInitialized) {
        // Resetting when reinitializing
        setIsBiconomyInitialized(false)
      }

      //   let walletWeb3
      //   if(
      //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      //       navigator.userAgent,
      //     )
      //   ){
      //     walletWeb3 = await Moralis.enableWeb3({
      //       provider: 'walletconnect',
      //       chainId: 56});
      //   }else{
      //     walletWeb3 = await Moralis.enableWeb3();
      //   }
      const networkProvider = new Web3.providers.HttpProvider(RPCURL)

      // if(chainId === '0x89'){

      const web3 = new Web3(Web3.givenProvider)

      const biconomy = new Biconomy(networkProvider, {
        walletProvider: window.ethereum, //web3WalletProvider --->  need to use web3 wallet provider
        apiKey: biconomyApiKey,
        debug: true,
      })

      setBiconomyProvider(biconomy)
      // This web3 instance is used to read normally and write to contract via meta transactions.
      web3.setProvider(biconomy)

      biconomy
        .onEvent(biconomy.READY, () => {
          // console.log("biconomy ready");
          setIsBiconomyInitialized(true)
          const AlterBodyABIMint: any[] = alterBodyABI.abi
          const contractInst = new web3.eth.Contract(
            AlterBodyABIMint,
            nftContractAddress
          )
          setContract(contractInst)
        })
        .onEvent(biconomy.ERROR, (ex: any) => {
          // console.log("biconomy error", ex);
          // Handle error while initializing mexa
          // notification.error({
          //   message: "Biconomy Initialization Fail",
          //   description:
          //     "Biconomy has failed to initialized. Please try again later.",
          // });
        })

      // }
    }

    // if ((isAuthenticated || account || user?.get('ethAddress')) && chainId !== "0x1") {
    // // console.log("Biconomy")
    initializeBiconomy()
    // }
  }, [abi, nftContractAddress])

  return (
    <BiconomyContext.Provider
      value={{ isBiconomyInitialized, biconomyProvider, contractAlter }}
    >
      {children}
    </BiconomyContext.Provider>
  )
}

export default BiconomyContextProvider
